export default __webpack_public_path__ + "static/media/img05.82286da3.png";